import { ReactNode } from "react";
import DashboardHeader from "./DashboardHeader";

export function DashboardTitle({
  children,
}: {
  children?: ReactNode | ReactNode[];
}) {
  return (
    <>
      <DashboardHeader />
      {children}
    </>
  );
}
export function DashboardTitleBlue({
  title,
  children,
  subtitle,
}: {
  title: string;
  subtitle: string;
  children?: ReactNode | ReactNode[];
}) {
  return (
    <div className="flex flex-col flex-grow bg-[#121212]">
      <div>
        <div className="relative mx-2 text-white text-[22px] font-bold leading-tight tracking-[0.06em] lg:pt-[38px] pt-5 sm:mx-10">
          {title}
        </div>
        <div className="relative mx-2 pt-2 pb-4 text-[#3B82F6] text-base font-medium leading-tight sm:mx-10">
          {subtitle}
        </div>
      </div>
      {children}
    </div>
  );
}

export function BigContainer({
  children,
  className,
}: {
  children?: ReactNode | ReactNode[];
  className?: string;
}) {
  return (
    <div
      className={
        "relative mx-2 sm:mx-10 mt-5 flex-grow flex flex-row mb-4" +
        (className ?? "")
      }
    >
      {children}
    </div>
  );
}
export function Container({
  children,
  className,
}: {
  children?: ReactNode | ReactNode[];
  className?: string;
}) {
  return (
    <div className={"relative mx-2 sm:mx-10 mt-5 " + (className ?? "")}>
      {children}
    </div>
  );
}

export function RoundBlock({
  children,
}: {
  children?: ReactNode | ReactNode[];
}) {
  return (
    <div className="rounded-lg flex-grow bg-[#121212] bg-opacity-50">
      {children}
    </div>
  );
}

export function BaseBlock({
  children,
}: {
  children?: ReactNode | ReactNode[];
}) {
  return (
    <div className="rounded-lg lg:rounded-b-none border-[#D8D8FC] border-2 lg:border-b-none bg-[#F8F8FF]">
      {children}
    </div>
  );
}

export function BaseBlockV2({
  children,
  className
}: {
  children?: ReactNode | ReactNode[];
  className?: string
}) {
  return (
    <div className={"rounded-lg shadow-md mb-6 bg-[#121212] bg-opacity-50 " + (className ?? '') }>
      {children}
    </div>
  );
}

export function Block({ children }: { children?: ReactNode | ReactNode[] }) {
  return (
    <div className="relative flex flex-col flex-grow mx-2 sm:mx-10 mt-5 rounded-lg lg:rounded-b-none border-[#D8D8FC] border-2 lg:border-b-none bg-[#F8F8FF]">
      {children}
    </div>
  );
}
